import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import LazyComponent from '../../../../LazyComponent';

export default universal(
    universalImport({
        chunkName: () => 'LazyCSPProgressedsChunk',
        path: () => path.join(__dirname, './CSPProgressConnect'),
        resolve: () => require.resolveWeak('./CSPProgressConnect'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "LazyCSPProgressedsChunk", webpackPreload: true */ './CSPProgressConnect'
                ),
            ]).then((proms) => proms[0]),
    }),
    LazyComponent.loaderResource
);
